require("./bootstrap");

window.Vue = require("vue");
const moment = require("moment");
const momentTimezone = require("moment-timezone");
import VueCookies from "vue-cookies";
import helpers from "./helpers";
import Select2 from "v-select2-component";
import VueCountdownTimer from "vuejs-countdown-timer";
import _ from "lodash";

const customPlugin = {
    install() {
        Vue.helpers = helpers;
        Vue.prototype.$helpers = helpers;
    },
};

Vue.use(require("vue-moment"), {
    moment,
    momentTimezone,
});
Vue.use(VueCookies);
Vue.use(customPlugin);
Vue.component("Select2", Select2);
Vue.use(VueCountdownTimer);

import registration from "./components/auth/Registration.vue";
import alerts from "./components/Alerts.vue";
import countdown from "./components/Countdown.vue";

const app = new Vue({
    el: "#app",
    data: {
        alertTimeout: 5000,
        alerts: [],
    },
    methods: {
        alert(type, message) {
            //Add alert
            let alert = { type: type, message: message };
            let alerts = this.alerts;
            alerts.push(alert);

            //Remove alert
            setTimeout(function () {
                alerts.splice(alerts.indexOf(alert), 1);
            }, this.alertTimeout);
        },
    },
    components: {
        alerts,
        registration,
        countdown,
    },
});

window.appAlert = app.alert;
